import Swiper, { Navigation, Pagination, Lazy } from 'swiper';
Swiper.use([Navigation, Pagination, Lazy]);

const initAfterSlider = () => {
  const slider = document.querySelector('.after__blocks');

  slider &&
    new Swiper(slider, {
      lazy: true,
      autoHeight: false,

      breakpoints: {
        1131: {
          spaceBetween: 20,
          slidesPerView: 3,
        },
        768: {
          spaceBetween: 20,
          slidesPerView: 2,
        },
        0: {
          spaceBetween: 10,
          slidesPerView: 1.3,
        },
      },
      navigation: {
        nextEl: '.after__next',
        prevEl: '.after__prev',
        disabledClass: 'last',
      },
    });
};

export default initAfterSlider;
